import { apiUrl } from "../../../config";
import axios from "axios";

const headers = () => ({
  "X-Requested-With": "XMLHttpRequest",
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("auth"),
});

export const state = {
  stats: null,
  notifications: [],
};

export const mutations = {
  SET_STATS(state, newValue) {
    state.stats = newValue;
  },
  SET_NOTIFICATIONS(state, newValue) {
    state.notifications = newValue || [];
  },
  MARK_NOTIFICATION_READ(state, key) {
    state.notifications = state.notifications.map((n) =>
      n.key === key ? { ...n, read: true } : n
    );
  },
  MARK_ALL_NOTIFICATIONS_READ(state) {
    state.notifications = state.notifications.map((n) => ({ ...n, read: true }));
  },
};

export const getters = {
  stats(state) {
    return state.stats;
  },
  notifications(state) {
    return state.notifications;
  },
  unreadNotificationsCount(state) {
    return state.notifications.filter((n) => !n.read).length;
  },
};

export const actions = {
  getStats({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/dashboard-stats", { headers: headers() })
        .then((response) => {
          commit("SET_STATS", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  getNotifications({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/notifications", { headers: headers() })
        .then((response) => {
          commit("SET_NOTIFICATIONS", response.data.data);
          resolve(response.data.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  // Marque une notification comme lue (optimiste : l'interface réagit tout
  // de suite, l'appel API ne fait que persister l'état).
  markNotificationRead({ commit }, { key }) {
    if (!key) return Promise.resolve(false);
    commit("MARK_NOTIFICATION_READ", key);
    return new Promise((resolve) => {
      axios
        .post(apiUrl + "api/notifications/read", { key }, { headers: headers() })
        .then(() => resolve(true))
        .catch(() => resolve(false));
    });
  },

  markAllNotificationsRead({ commit, state }) {
    const keys = state.notifications.filter((n) => !n.read).map((n) => n.key);
    if (!keys.length) return Promise.resolve(false);
    commit("MARK_ALL_NOTIFICATIONS_READ");
    return new Promise((resolve) => {
      axios
        .post(
          apiUrl + "api/notifications/read-all",
          { keys },
          { headers: headers() }
        )
        .then(() => resolve(true))
        .catch(() => resolve(false));
    });
  },

  // Résumé d'un dossier (colonne latérale de la page Dossier)
  // eslint-disable-next-line no-unused-vars
  getDossierResume({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/dossier-resume/" + id, { headers: headers() })
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  // Recherche globale de la topbar : dossiers/clients par référence ou nom.
  // eslint-disable-next-line no-unused-vars
  globalSearch({ commit }, { search }) {
    return new Promise((resolve, reject) => {
      axios
        .get(apiUrl + "api/clients", {
          headers: headers(),
          params: { search: search, per_page: 6, page: 1 },
        })
        .then((response) => {
          const payload =
            response.data.data && response.data.data.data
              ? response.data.data.data
              : [];
          resolve(payload);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};
